import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import DIOText from "../../components/DIOText";
// hooks
import useResponsive from '../../hooks/useResponsive';


export default function WhyTodoDialog({ isOpen, closeDialog}) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="sm">
      <DialogContent sx={{ my: { xs: 0, sm: 1}  }}>
        <Typography variant="h5" sx={{ mb: { xs : 3, sm : 4 } }}>
          데일리 투두, 왜 작성하나요?
        </Typography>
        <Typography variant="h6" gutterBottom>
          🙋‍♀️ 업무 관리, 공유가 쉬워져요.
        </Typography>
        <Typography paragraph sx={{ color: 'text.secondary' }} variant={smUp ? "body1" : "body2"}>
          앞으로 어떤 일을 할지, 지금까지 어떤 일을 했는지 회사가 실시간으로 확인할 수 있어요.
        </Typography>
        <Typography variant="h6" gutterBottom>
          ⏰ 작업 시간 기반으로 소통할 수 있어요.
        </Typography>
        <Typography sx={{ color: 'text.secondary' }} variant={smUp ? "body1" : "body2"}>
          업무에 실제로 투입한 시간은 예상과 다를 수 있어요.<br/>소요 시간을 공유하면, 리소스 사용을 회사와 <DIOText />가 파악할 수 있어요.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ px: 4 }}
          fullWidth={smUp ? false : true}
          onClick={closeDialog}
          variant="contained"
          size="large"
        >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}